document.addEventListener("DOMContentLoaded", function () {
  const prevButton = document.querySelector(".prev-page-cpt-investigador");
  const nextButton = document.querySelector(".next-page-cpt-investigador");

  let currentPage = 1;
  const postId = globalData.postId;

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      currentPage--;
      fetchPosts(currentPage, postId);
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      currentPage++;
      fetchPosts(currentPage, postId);
    });
  }

  const fetchPosts = async (page, investigador_id) => {
    try {
      const response = await fetch(
        `${paginationData.siteUrl}/wp-json/user_content_card/v1/get-cpt-posts/?page=${page}&investigator-id=${investigador_id}`,
        {
          headers: {
            "X-WP-Nonce": paginationData.nonce,
          },
        }
      );
      //console.log(response);
      if (!response.ok) {
        // Verifica si la respuesta fue exitosa
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      // Actualiza los posts en la página sin recargar
      const postsContainer = document.querySelector(
        ".container-researcher-posts"
      );
      const postsListContainer = document.querySelector(
        ".researcher-posts__list"
      );
      //postsContainer.innerHTML = ''; // Limpiar los posts anteriores
      const totalPagination = data.pagination["total"];
      data.posts.forEach((post) => {
        const postHTML = `
                    <a class="user-content-card" href="${
                      post["the-permalink"]
                    }">
                        ${
                          post["image-cpt"]
                            ? `<figure><img src="${post["image-cpt"]}" class="user-content-card-img"/></figure>`
                            : ""
                        }
                        <p class="user-content-card-title">${
                          post["title-cpt"]
                        }</p>
                        ${
                          post["categories-cpt"]
                            ? `
                        <div class="user-content-card-container-categories">
                            ${post["categories-cpt"]
                              .map(
                                (category) =>
                                  `<p class="user-content-card-category">#${category["name"]}</p>`
                              )
                              .join("")}
                        </div>`
                            : ""
                        }
                    </a>`;

        postsListContainer.insertAdjacentHTML("beforeend", postHTML);
      });
      if (totalPagination > 1) {
        let paginationHTML =
          '<div class="pagination user-content-card__container-pagination">';
        /* if(page > 1){
                    paginationHTML += '<button class="prev-page-cpt-investigador">Anterior</button>';
                } */
        if (page < data.pagination["total"]) {
          paginationHTML += `<button class="next-page-cpt-investigador">${wp.i18n.__("Ver más entrevistas","eureka")}</button>`;
        }
        paginationHTML += "</div>";
        postsContainer.insertAdjacentHTML("beforeend", paginationHTML);
        // Reasignar eventos de los botones de paginación
        /* document.querySelector('.prev-page-cpt-investigador')?.addEventListener('click', () => {
                   if (currentPage > 1) {
                       currentPage--;
                       fetchPosts(currentPage,postId);
                   }
               }); */

        document
          .querySelector(".next-page-cpt-investigador")
          ?.addEventListener("click", () => {
            if (currentPage < data.pagination["total"]) {
              currentPage++;
              fetchPosts(currentPage, postId);
            }
          });
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  // Primera carga
  //fetchPosts(currentPage);
});
